import React from 'react';
import { Box, Button, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { Card } from '../Card';
import { Typography } from '../Typography';

interface BaseEditFormLayoutProps {
    onRemove?(): void;
    title: string;
    buttonText: string;
    isDialogView?: undefined;
    onClose?: undefined;
}

interface DialogEditFormLayoutProps extends Omit<BaseEditFormLayoutProps, 'isDialogView' | 'onClose'> {
    isDialogView: true;
    onClose(): void;
}

type EditFormLayoutProps = BaseEditFormLayoutProps | DialogEditFormLayoutProps;

const EditFormLayout: React.FC<EditFormLayoutProps> = ({ children, onRemove, title, buttonText, isDialogView, onClose }) => (
    <Card style={isDialogView ? { height: '100%', overflow: 'auto' } : undefined}>
        <Box px={3} py={isDialogView ? 2 : 5}>
            {isDialogView
                ? (
                    <>
                        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                            <ArrowBack />
                        </IconButton>
                        <Box mb={2} />
                    </>
                ) : null}
            <Box display='flex' justifyContent='space-between' alignItems='flex-start'>
                <Typography variant='h6' component='h1'>{title}</Typography>
                {onRemove
                    ? (
                        <Button onClick={onRemove} variant="outlined" color="secondary">
                            {buttonText}
                        </Button>
                    ): null}
            </Box>
            {children}
        </Box>
    </Card>
);

export default EditFormLayout;
